import { ApprovalAdditionalField } from '@dill/dill-shared';

type ApprovalFieldOption = NonNullable<ApprovalAdditionalField['options']>[number];

// A dropdown approval field's options: the supplier's branches (by name, with the branch's ERP id)
// when the field's optionsSource is SUPPLIER_BRANCHES, else the options set on the template.
export const getApprovalFieldOptions = (
  field: ApprovalAdditionalField,
  branches: { branchName?: string | null; erpId?: string | null }[]
): ApprovalFieldOption[] => {
  if (field.optionsSource !== 'SUPPLIER_BRANCHES') {
    return field.options ?? [];
  }
  const seen = new Set<string>();
  return branches
    .map((branch) => ({ name: branch.branchName?.trim() ?? '', erpId: branch.erpId?.trim() ?? '' }))
    .filter((branch) => !!branch.name && !seen.has(branch.name) && !!seen.add(branch.name))
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((branch) => (branch.erpId ? branch : branch.name));
};
